import { Controller } from 'react-hook-form';

import { InputOption } from 'components/common/MyCustomSelect/components/InputOption/InputOption';
import { ValueContainer } from 'components/common/MyCustomSelect/components/ValueContainer/ValueContainer';

import { Select } from 'components/DesignSystem/Select';
import classes from 'components/widgets/ChangeAnalysisTrackedActivities/tableLocalFilters/tableLocalFilters.module.scss';
import { statusOptions } from 'components/widgets/KeyActivities/components/filter.utils';

export const StatusFilter = ({ control }) => {
    return (
        <div className={classes.selectWrapper}>
            <div className={classes.title}>Status</div>
            <Controller
                render={({ field }) => (
                    <Select<ISelectOption<string>, true>
                        {...field}
                        options={statusOptions}
                        isClearable={true}
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        isMulti={true}
                        placeholder={'Select Status...'}
                        components={{
                            Option: InputOption,
                            ValueContainer: ValueContainer,
                        }}
                    />
                )}
                name={'status'}
                control={control}
            />
        </div>
    );
};
